import { UseDisclosureHandlers } from "@mantine/hooks"
import { AreYouSureModal, Loader } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import { useDeleteContactMutation } from "~/pages/Brand/Suppliers/SuppliersRepository/hooks/useDeleteContactMutation"

type DeleteContactProps = {
  id: string
  isDeleteModalOpen: boolean
  deleteModalActions: UseDisclosureHandlers
}

const DeleteContact = ({
  id,
  isDeleteModalOpen,
  deleteModalActions,
}: DeleteContactProps) => {
  const { t } = useTranslation("organizationSettings")

  const { mutate: deleteSupplierMapping, isPending: isLoading } =
    useDeleteContactMutation({ searchSupplier: "" })

  if (isLoading) {
    return <Loader />
  }

  return (
    <>
      <AreYouSureModal
        opened={isDeleteModalOpen}
        onClose={deleteModalActions.close}
        confirmText={t("supplierSettings.deleteSupplier.confirm")}
        cancelText={t("supplierSettings.deleteSupplier.cancel")}
        onConfirm={() =>
          deleteSupplierMapping(
            { id },
            {
              onSettled: deleteModalActions.close,
            }
          )
        }
        areYouSureText={t("supplierSettings.deleteSupplier.message")}
        title={t("supplierSettings.deleteSupplier.title")}
      />
    </>
  )
}

export default DeleteContact
